import { IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { MdInfo } from "react-icons/md";


const SFInfoIcon = ({helpText}) => {
    return (
        <Tooltip
        title={
            <Typography fontSize={12} color='#fff' sx={{ whiteSpace: 'pre-wrap' }}>
                {helpText}
            </Typography>
        } placement="top" arrow>
            <IconButton className='mx-1' size='small' aria-label={helpText} onClick={(event) => event.stopPropagation()}>
                <MdInfo aria-hidden='true' color='gray' fontSize={18} />
            </IconButton>
        </Tooltip>
    );
}

export default SFInfoIcon;
